import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=32285cde&scoped=true&"
import script from "./PermissionItem.vue?vue&type=script&lang=js&"
export * from "./PermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItem.vue?vue&type=style&index=0&id=32285cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32285cde",
  null
  
)

export default component.exports